import React, { useCallback, useContext } from 'react'
import Dashboard from './Dashboard'
import * as subscriptionActions from '../../subscriptions/store/actions'
import { AppContext } from '../../../global'
import { useParams } from 'react-router-dom'
import { Params } from '../../types'

function DashboardRoute() {
  const { state, execute } = useContext(AppContext)
  const { partnerId } = useParams() as Params
  const loadFilters = useCallback(async function (partnerId: string) {
    await execute(subscriptionActions.loadFilters(partnerId))
  }, [execute])


  return (
    <Dashboard
      partnerId={partnerId}
      state={state.filters}
      loadFilters={loadFilters}
    />
  )
}

export default DashboardRoute
